<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.AutoType.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtAutoTypeName"><small v-show="form.name.required" class="text-danger">*</small> {{$lang.AutoType.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAutoTypeName"
                              :placeholder="$lang.AutoType.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="cbxType"><small v-show="form.ranking.required" class="text-danger">*</small> {{$lang.AutoType.LabelRanking}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.ranking.value"
                              :options="form.ranking.options"
                              :state="form.ranking.state"
                              class="mb-3"
                              name="cbxType">
                    <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                    <option :value="1">{{$lang.AutoType.Ranking.Light}}</option>
                    <option :value="2">{{$lang.AutoType.Ranking.Heavy}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.AutoType.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.AutoType.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.AutoType.DataTable.Ranking,
                       $lang.AutoType.DataTable.Name,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="(obj.ranking > 0 && obj.ranking === 1) ? $lang.AutoType.Ranking.Light : ((obj.ranking > 0 && obj.ranking === 2) ? $lang.AutoType.Ranking.Heavy : null) "   />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" classCss="text-left" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsActionsButtons="true" :HasDelete="false" v-on:Change="onChange(obj)"  :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import AutoType from './autotype.js'

export default AutoType
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/autotype/autotype.vue